"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

exports.SVG = function () {
  return react_1["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none"
  }, react_1["default"].createElement("path", {
    d: "M12.464 13.806C12.464 13.806 12.264 14.306 11.714 14.066L9.681 12.507L8.377 13.697C8.377 13.697 8.275 13.774 8.164 13.726L8.414 11.517L8.422 11.524L8.427 11.478C8.427 11.478 12.084 8.191 12.234 8.051C12.384 7.911 12.334 7.881 12.334 7.881C12.344 7.711 12.064 7.881 12.064 7.881L7.218 10.958L5.2 10.28C5.2 10.28 4.89 10.169 4.86 9.93C4.83 9.69 5.21 9.56 5.21 9.56L13.234 6.412C13.234 6.412 13.893 6.122 13.893 6.602L12.464 13.806ZM10 2C5.582 2 2 5.582 2 10C2 14.418 5.582 18 10 18C14.419 18 18 14.418 18 10C18 5.582 14.419 2 10 2Z",
    fill: "#727B7F"
  }));
};